export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senha antiga:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova senha:"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmação de senha:"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Nova senha\" e \"Confirmação de senha\" não coincidem."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alterar senha"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De 4 a 63 caracteres. Caracteres permitidos: letras latinas, números e símbolos"])}
}